var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Angle-Right_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 8,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.407 3 5.021 4.623a.516.516 0 0 1 0 .754L6.407 13",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Angle-Right_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }))));
};
export { SvgAngleRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIxODdfMjcwNiIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iNSIgeT0iMiIgd2lkdGg9IjgiIGhlaWdodD0iMTIiPgo8cGF0aCBkPSJNNi40MDY5OCAzTDExLjQyODUgNy42MjMwOEMxMS40OCA3LjY3MTQyIDExLjUyMTEgNy43Mjk4MSAxMS41NDkxIDcuNzk0NjRDMTEuNTc3MiA3Ljg1OTQ3IDExLjU5MTcgNy45MjkzNiAxMS41OTE3IDhDMTEuNTkxNyA4LjA3MDY0IDExLjU3NzIgOC4xNDA1NCAxMS41NDkxIDguMjA1MzZDMTEuNTIxMSA4LjI3MDE5IDExLjQ4IDguMzI4NTggMTEuNDI4NSA4LjM3NjkyTDYuNDA2OTggMTMiIHN0cm9rZT0iIzE0MTYxQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjE4N18yNzA2KSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iIzE0MTYxQSIvPgo8L2c+Cjwvc3ZnPgo=";